import { render, staticRenderFns } from "./user-dropdown.vue?vue&type=template&id=77a15df2&scoped=true&"
import script from "./user-dropdown.vue?vue&type=script&lang=ts&"
export * from "./user-dropdown.vue?vue&type=script&lang=ts&"
import style0 from "./user-dropdown.vue?vue&type=style&index=0&id=77a15df2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77a15df2",
  null
  
)

export default component.exports